"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/routing";
import { AlertTriangleIcon, ArrowLeftIcon, RefreshCwIcon } from "lucide-react";
import { useTranslations } from "next-intl";
export default function Error(t0) {
  const $ = _c(28);
  const {
    reset
  } = t0;
  const t = useTranslations("error");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pointer-events-none absolute inset-0 overflow-hidden"><div className="absolute top-1/3 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-[radial-gradient(circle,hsl(var(--destructive)/0.08),transparent_70%)]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10"><AlertTriangleIcon className="h-10 w-10 text-destructive" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("title");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <h1 className="text-2xl font-semibold text-foreground sm:text-3xl">{t3}</h1>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("description");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <p className="max-w-md text-muted-foreground">{t5}</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RefreshCwIcon className="h-4 w-4" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("retry");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== reset || $[14] !== t8) {
    t9 = <Button onClick={reset} variant="outline" className="gap-2">{t7}{t8}</Button>;
    $[13] = reset;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ArrowLeftIcon className="h-4 w-4" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("backHome");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <Button asChild={true} className="gap-2"><Link href="/">{t10}{t11}</Link></Button>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t9) {
    t13 = <div className="mt-4 flex gap-3">{t9}{t12}</div>;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t4 || $[26] !== t6) {
    t14 = <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">{t1}<div className="relative z-10 flex flex-col items-center gap-6">{t2}{t4}{t6}{t13}</div></div>;
    $[24] = t13;
    $[25] = t4;
    $[26] = t6;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}